import React, { Dispatch, SetStateAction, useState } from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { ErrorM } from 'components/formComponents/ErrorM';
import { postWithParams } from 'helpers/endpointCalls';
import { endpoints } from 'endpoints.config';
import { selectQuotesId } from 'reducers/misc';
import { useSelector } from 'react-redux';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  membershipQuestions: any;
  setMembershipQErr: Dispatch<SetStateAction<boolean>>;
  setQuoteBtnTxt: Dispatch<SetStateAction<string>>;
  setDisableQuoteBtn: Dispatch<SetStateAction<boolean>>;
};

export const EmailQuoteModal: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  membershipQuestions,
  setMembershipQErr,
  setQuoteBtnTxt,
  setDisableQuoteBtn,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [initialDetails, setInitialDetails] = useState<any>({
    firstName: "",
    lastName: "",
    emailAddress: "",
    schoolName: "",
    postCode: "",
  });	

  const quotesId: number | null = useSelector(selectQuotesId);

  const validationSchema = Yup.object({
    firstName: Yup.string().required('Please enter a first name'),
    lastName: Yup.string().required('Please enter a last name').nullable(),
    emailAddress: Yup.string().required('Please enter an email address').email('Must be a valid email address'),
    schoolName: Yup.string().required('Please enter a school name').nullable(),
    postCode: Yup.string().required('Please enter a post code').nullable(),
  });	  

  const handleSubmit = async (values: any) => {
    setLoading(true);

    const payload = {
      quotesId: quotesId,
      firstName: values.firstName,
      lastName: values.lastName,
      emailAddress: values.emailAddress,
      schoolName: values.schoolName,
      postCode: values.postCode,
    };

    const result = await postWithParams(endpoints.public.subscription.sendQuoteEmail, payload);  

		if (result.response && !result.errors) {
      togglePanelOpen(false);
      setQuoteBtnTxt("Your quote has been sent");
      setDisableQuoteBtn(true);
		} else {
			setMembershipQErr(true);
      togglePanelOpen(false);
		}	    
  };

  return (
    <Formik
      initialValues={initialDetails}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validateOnBlur={false}
      validateOnMount={false}
      enableReinitialize={true}
      validationSchema={validationSchema}
    >
      {(formik) => {
        let values: any = formik.values;

        return (
          <Form>
            <PopupOrPanel
              isPopup={true}
              isOpen={panelOpen}
              hdrTitle="Email quote"
              position="right"
              primaryBtnTxt="Submit"
              secondaryBtnTxt="Cancel"
              givenClass="EmailQuoteModal"
              primaryBtnColor="BtnOrange"
              handleClose={() => togglePanelOpen(false)}
              handlePrimaryBtn={() => formik.submitForm()}
              handleSecondaryBtn={() => togglePanelOpen(false)}
              width={460}
              isSubmitting={loading}
            >
              <div className="EmailQuoteForm">
                <div className="FormBox FirstName">
                  <div className="FormLabel"><label htmlFor="firstName">First name</label></div>
                  <div className="FormField">
                    <input type="text" id="firstName" name="firstName" className={"EditBox" + (formik.errors.firstName ? " ErrorInput" : "")} value={values.firstName} onChange={(e) => formik.setFieldValue("firstName", e.target.value)} />
                    <ErrorM name="firstName" />
                  </div>
                </div>
                <div className="CellSpacer"></div>
                <div className="FormBox LastName">
                  <div className="FormLabel"><label htmlFor="lastName">Last name</label></div>
                  <div className="FormField">
                    <input type="text" id="lastName" name="lastName" className={"EditBox" + (formik.errors.lastName ? " ErrorInput" : "")} value={values.lastName} onChange={(e) => formik.setFieldValue("lastName", e.target.value)} />
                    <ErrorM name="lastName" />
                  </div>
                </div>
                <div className="LineSpacer1"></div>
                <div className="FormBox EmailAddress">
                  <div className="FormLabel"><label htmlFor="emailAddress">Email address</label></div>
                  <div className="FormField">
                    <input type="text" id="emailAddress" name="emailAddress" className={"EditBox" + (formik.errors.emailAddress ? " ErrorInput" : "")} value={values.emailAddress} onChange={(e) => formik.setFieldValue("emailAddress", e.target.value)} />
                    <ErrorM name="emailAddress" />
                  </div>
                </div>
                <div className="FormBox SchoolName">
                  <div className="FormLabel"><label htmlFor="schoolName">School name</label></div>
                  <div className="FormField">
                    <input type="text" id="schoolName" name="schoolName" className={"EditBox" + (formik.errors.schoolName ? " ErrorInput" : "")} value={values.schoolName} onChange={(e) => formik.setFieldValue("schoolName", e.target.value)} />
                    <ErrorM name="schoolName" />
                  </div>
                </div>
                <div className="CellSpacer"></div>
                <div className="FormBox Postcode">
                  <div className="FormLabel"><label htmlFor="postCode">Postcode</label></div>
                  <div className="FormField">
                    <input type="text" id="postCode" name="postCode" className={"EditBox" + (formik.errors.postCode ? " ErrorInput" : "")} value={values.postCode} onChange={(e) => formik.setFieldValue("postCode", e.target.value)} />
                    <ErrorM name="postCode" />
                  </div>
                </div>
                <div className="LineSpacer1"></div>
              </div>
            </PopupOrPanel>
          </Form>
        );
      }}
    </Formik>
  );
};
